// İSG Portal — yükleniyor göstergesi (Lucide + token renk).

import { Loader2 } from 'lucide-react';
import { cn } from './cn';

export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <output aria-live="polite" className="inline-flex items-center gap-2">
      <Loader2 className={cn('h-4 w-4 animate-spin text-muted', className)} aria-hidden="true" />
      {label ? <span className="text-sm text-muted">{label}</span> : null}
    </output>
  );
}
